export default "__VITE_ASSET__DKLqWc_G__"